import { Icon } from "@blueprintjs/core"
import { DirectionsService, InfoWindow, Marker } from "@react-google-maps/api"
import { get } from "lodash-es"
import React, { useState } from "react"
import { getPosition } from "utils/custom.utils"
import OrdersPreview from "../trip/front-end/OrdersPreview"
import LiveVehicleMarker from "../trip/LiveVehicleMarker"
import RenderDirection from "./RenderDirection"
export default function TripDirectionsService({
  bookings,
  source,
  destination,
}) {
  const [response, changeResponse] = useState(false)

  function directionsCallback(res) {
    if (res !== null) {
      if (res.status === "OK") {
        if (!response) changeResponse(res)
      }
    }
  }

  const paths = get(response, "routes.0.overview_path", [])
  const midPoint = get(paths, [Math.round(paths.length / 2)])
  //

  const waypoints = bookings?.map(b => {
    if (b?.shippingAddress) {
      return getPosition(b?.shippingAddress)
    } else {
      return getPosition(b?.schedule?.plot?.address)
    }
  })

  const src = getPosition(source?.location)
  const dest = getPosition(destination?.location)

  return (
    <>
      <Marker
        title={`Source - ${source?.name}`}
        icon={{
          scaledSize: new window.google.maps.Size(41, 41),
          url: "https://cdn.vesatogo.com/images/business-and-trade_1.svg",
        }}
        position={src}
      />
      <Marker
        title={`Destination - ${destination?.name}`}
        icon={{
          scaledSize: new window.google.maps.Size(41, 41),
          url: "https://cdn.vesatogo.com/images/business-and-trade.svg",
        }}
        position={dest}
      />
      <LiveVehicleMarker />

      <OrdersPreview bookings={bookings} />
      {dest && src && (
        <DirectionsService
          options={{
            waypoints: waypoints.map(location => {
              return {
                location,
                stopover: true,
              }
            }),
            destination: dest,
            origin: src,
            travelMode: "DRIVING",
          }}
          callback={directionsCallback}
        />
      )}

      {response !== null && <RenderDirection response={response} />}

      {midPoint && (
        <InfoWindow position={midPoint}>
          <div>
            <p className="m-0">
              <Icon icon="drive-time" />{" "}
              {get(response, "routes.0.legs.0.distance.text")}
            </p>
            <p className="m-0 text-sm vt-muted">
              {get(response, "routes.0.legs.0.duration.text")}
            </p>
          </div>
        </InfoWindow>
      )}
    </>
  )
}
